"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("./DataObjectConverter");
/**
 */


var ProjectableDataObjectConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ProjectableDataObjectConverter, _DataObjectConverter_);

  function ProjectableDataObjectConverter() {
    _classCallCheck(this, ProjectableDataObjectConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProjectableDataObjectConverter).apply(this, arguments));
  }

  return ProjectableDataObjectConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ProjectableDataObjectConverter = ProjectableDataObjectConverter;